
import { uniqueId } from 'lodash'
import NrButton from '../NrButton/nr-button.vue'
import Vue from 'vue'
import { Tab } from 'nr-tab.vue'
const COMPONENT_NAME = 'nr-tabs'

export default {
  props: {
    ariaLabel: { type: String, default: 'Tabs' },
    // id of active tab.
    modelValue: { type: String, required: false }
  },
  emits: ['update:modelValue'],
  components: { NrButton },
  provide() {
    return {
      registerTab: this.registerTab,
      activeTabId: () => this.activeTabId
    }
  },
  data() {
    return {
      tabs: [] as Tab[],
      tabFocusIndex: 0,
      // If no `modelValue` prop is provided then we need to store the active tab internally.
      internalActiveTabId: null,
      id: uniqueId(`${COMPONENT_NAME}-`)
    }
  },
  computed: {
    // Depending on whether the `modelValue` prop is provided we use that or the internally stored version.
    activeTabId(): string {
      return this.modelValue || this.internalActiveTabId
    }
  },
  methods: {
    registerTab(tab: Tab): void {
      this.tabs.push(tab)
      if (!this.activeTabId) {
        this.selectTab(tab.id)
      }
    },
    selectTab(tabId: number): void {
      this.internalActiveTabId = tabId
      this.$emit('update:modelValue', tabId)
    },
    setupKeyDownEvent(e: KeyboardEvent): void {
      let tabButtons = this.$refs.tabButtons || []
      if (!Array.isArray(tabButtons)) {
        tabButtons = [tabButtons]
      }
      const tabButtonsLength = tabButtons.length

      // Right(39)/Left(37) arrow keys
      if (e.keyCode === 39 || e.keyCode === 37) {
        const tabButton = (tabButtons[this.tabFocusIndex] as Vue)
          .$el as HTMLElement
        tabButton.setAttribute('tabindex', '-1')

        // Move right
        if (e.keyCode === 39) {
          this.tabFocusIndex = this.tabFocusIndex + 1
          // Move left
        } else if (e.keyCode === 37) {
          this.tabFocusIndex = this.tabFocusIndex - 1
        }

        this.tabFocusIndex = this.tabFocusIndex % tabButtonsLength
        if (this.tabFocusIndex < 0) this.tabFocusIndex = tabButtonsLength - 1
      }
      const tabButton = (tabButtons[this.tabFocusIndex] as Vue)
        .$el as HTMLElement
      tabButton.setAttribute('tabindex', '0')
      tabButton.focus()
    }
  }
}
